import { ExpertAnketaQuestionsEvaluation } from './ExpertAnketaQuestionsEvaluation';

export default ExpertAnketaQuestionsEvaluation;